import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, Subject, Subscription } from 'rxjs';
import { CampaignUrlBuilder } from './url-builder';
import { filter, map } from 'rxjs/operators';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class CampaignEntityService {

  loading: boolean = false;
  campaign: any;
  campaignUrl: string;
  sub: Subject<any> = new Subject<any>();
  routeChangeSubscription: Subscription;

  constructor(private httpClient: HttpClient,
              private router: Router,
              private route: ActivatedRoute,
              private urlBuilder: CampaignUrlBuilder) {
    this.init();
  }

  init() {
    this.routeChangeSubscription = this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map(() => this.route)
    )
      .subscribe((event: any) => {
        const url = this.urlBuilder.buildUrl('');
        if (url !== this.campaignUrl) {
          this.campaignUrl = url;
          this.campaign = false;
        }
      });
  }

  load(cache = true) {
    const url = this.urlBuilder.buildUrl('');
    if (url === '/campaign') {
      return;
    }
    if (this.campaignUrl === url && this.campaign && cache) {
      return;
    }
    this.campaignUrl = url;
    this.httpClient.get(this.campaignUrl)
      .subscribe((response: any) => {
        this.sub.next(response);
        this.campaign = response;
        this.loading = false;
      }, (e) => {
        this.sub.error(e);
        this.loading = false;
        this.router.navigate([ '/campaign' ]);
      });
  }

  getCampaign(cache: boolean = true): Observable<any> {
    if (!this.campaign || !cache) {
      if (!this.loading) {
        this.load(cache);
        this.loading = true;
      }
      return this.sub;
    } else {
      return of(this.campaign);
    }
  }
}
